module.exports = __webpack_public_path__ + "media/images/icon_map_placemark_inactive-4c70c7d4.svg";